import { usePlanGate } from '@/hooks/usePlanGate';
import { useRole } from '@/hooks/useRole';
import { Button } from '@/components/ui/button';
import { Lock, Sparkles, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

type Feature = 'funds' | 'lp-portal' | 'documents' | 'reports' | 'kpis' | 'cap-table' | 'api-keys' | 'web-search' | 'research' | 'discovery';

interface PlanGatedPageProps {
  children: React.ReactNode;
  feature: Feature;
  featureLabel: string;
}

export function PlanGatedPage({ children, feature, featureLabel }: PlanGatedPageProps) {
  const { canAccess, tierLabel } = usePlanGate();
  const navigate = useNavigate();

  if (!canAccess(feature)) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[60vh] p-8 text-center gap-6">
        <div className="p-4 rounded-2xl bg-primary/10 border border-primary/20">
          <Lock className="h-8 w-8 text-primary" />
        </div>
        <div>
          <h2 className="text-xl font-bold text-foreground mb-2">{featureLabel}</h2>
          <p className="text-muted-foreground max-w-md">
            This feature is available on the <span className="text-primary font-semibold">Pro</span> and{' '}
            <span className="text-primary font-semibold">Enterprise</span> plans. 
            You're currently on the <span className="font-medium">{tierLabel}</span> plan.
          </p>
        </div>
        <div className="flex gap-3">
          <Button variant="outline" onClick={() => navigate(-1)}>
            <ArrowLeft className="h-4 w-4 mr-2" />
            Go Back
          </Button>
          <Button onClick={() => navigate('/settings')} className="gap-2">
            <Sparkles className="h-4 w-4" />
            Upgrade Plan
          </Button>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
